import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { Controller } from 'src/app/core/models/controller.model';
import { Location } from 'src/app/core/models/project/location.model';
import { ApiLocationsService } from 'src/app/shared/services/api-locations.service';
import { LocationsService } from 'src/app/shared/services/locations.service';

@Component({
  selector: 'app-access-control-modal-service',
  templateUrl: './access-control-modal-service.component.html',
  styleUrls: ['./access-control-modal-service.component.scss'],
})
export class  AccessControlModalServiceComponent implements OnInit {
  @Input() controllers: Controller[];
  locations$: Observable<Location[]> = this.locationsService.getLocations();
  selectedLocation: Location;
  selectedController: Controller;

  constructor(
    private locationsService: LocationsService,
    private apiLocationsService: ApiLocationsService,
    private changeDetectionRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.apiLocationsService.getLocations().subscribe();
  }

  selectLocation(locationId: string) {
    this.selectedLocation = null;
    this.selectedController = null;
    this.changeDetectionRef.detectChanges();
    this.locations$.pipe(take(1)).subscribe((locations) => {
      this.selectedLocation = locations.find((loc) => {
        return loc.fullLocationId === locationId;
      });
    });
  }

  selectController(controller: Controller) {
    this.selectedLocation = null;
    this.selectedController = null;
    this.changeDetectionRef.detectChanges();
    this.selectedController = controller;
  }

  cancelSelection() {
    this.selectedLocation = null;
    this.selectedController = null;
  }
}
